<!-- @format -->
<template>
    <div class="account-gateway-view">
        <div class="h-container-fluid">
            <div class="h-row">
                <div class="h-col-md-7">
                    <account-gateway 
                        :isConnectwise="isConnectwise" 
                        :isChartec="isChartec" 
                        :isBitdefender="isBitdefender" 
                        :isSophos="isSophos" 
                        :isSentinelOne="isSentinelOne" />
                </div>
                <div class="h-col-md-5 graphic-column">
                    <div v-if="isConnectwisePartnerProgram" class="background">
                        <img src="@/assets/images/cw-logos-design.png" />
                    </div>
                    <connectwise-carousel v-else-if="isConnectwise" />
                    <chartec-carousel v-else-if="isChartec" />
                    <bitdefender-carousel v-else-if="isBitdefender" />
                    <sophos-carousel v-else-if="isSophos" />
                    <sentinelone-carousel v-else-if="isSentinelOne" />
                    <account-carousel v-else />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AccountGateway = () => import('@/components/account/account-gateway');
const AccountCarousel = () => import('@/components/account/account-carousel');
const ConnectwiseCarousel = () => import('@/components/account/connectwise-carousel');
const ChartecCarousel = () => import('@/components/account/chartec-carousel');
const BitdefenderCarousel = () => import('@/components/account/bitdefender-carousel');
const SophosCarousel = () => import('@/components/account/sophos-carousel');
const SentinelOneCarousel = () => import('@/components/account/sentinelone-carousel');


export default {
    components: {
        'account-gateway': AccountGateway,
        'account-carousel': AccountCarousel,
        'connectwise-carousel': ConnectwiseCarousel,
        'chartec-carousel': ChartecCarousel,
        'bitdefender-carousel': BitdefenderCarousel,
        'sophos-carousel': SophosCarousel,
        'sentinelone-carousel': SentinelOneCarousel,
    },

    computed: {
        isConnectwise() {
            return this.$route.name === 'AccountSignupCW';
        },

        isConnectwisePartnerProgram() {
            return this.$route.name === 'PartnerProgramCW';
        },

        isChartec() {
            return this.$route.name === 'AccountSignupChartec';
        },

        isBitdefender() {
            return this.$route.name === 'AccountSignupBitdefender';
        },

        isSophos() {
            return this.$route.name === 'AccountSignupSophos';
        },

        isSentinelOne() {
            return this.$route.name === 'AccountSignupSentinelOne';
        },
    },

    data() {
        return {};
    },
};
</script>

<style>
.account-gateway-view {
    padding: 0;
    background: #fff;
    overflow-y: hidden;
}

.account-gateway-view .graphic-column .background {
    background-image: url('../../assets/images/Background.png');
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.account-gateway-view .graphic-column .background img {
    max-width: 637px;
    height: auto;
    width: 90%;
}

.account-gateway-view .graphic-column {
    padding: 0;
}

.account-gateway-view {
    height: 100%;
}

@media (max-width: 768px) {
    .account-gateway-view .account-gateway {
        width: 100%;
        padding: 0;
    }
}
</style>
